<template>
  <v-container
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0"
    >
      <v-card
        elevation="10"
        width="100%"
        :loading="isLoading"
      >
        <v-card-title class="title">Resumo do seu processamento</v-card-title>
        <v-divider/>
        <v-card-text>
          <v-skeleton-loader
            :loading="isLoading"
            type="table-row-divider, table-row-divider, table-row-divider, table-row-divider"
            class="mx-auto flex-fill"
            width="100%"
          >
            <processing-summary-items
              :items="processingInfo"
            >
            </processing-summary-items>
          </v-skeleton-loader>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row
      align="center"
      justify="start"
      class="actions my-10"
    >
      <v-btn
        @click="LastStep"
        color="accent"
        outlined
      >
        Voltar
      </v-btn>
      <v-spacer/>
      <v-btn
        @click="onNextClick"
        :loading="isLoading || isLoadingNext"
        color="primary"
      >
        Próximo
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from "vuex"
  import {
    CALCULATE_PROCESSING_DATA,
    GET_ID_PROCESSING,
    GET_MUST_CALCULATE_PROCESSING_DATA,
    GET_PROCESSING_DATA,
  } from "../../../store/modules/processing"
  import {
    cameraTypeToName,
    georeferenceTypeToName,
    PROCESSING_STEPS,
    PROCESSING_TYPES,
    processingTypeToName,
    templateTypeToName,
  } from "../../../helpers/processings/constants"
  import {isEqual} from "lodash/lang"
  import moment from "moment"
  import "moment/locale/pt-br"
  import ProcessingSummaryItems from "./ProcessingSummaryItems"
  import {ProcessingStepperEventBus} from "../../../helpers/processings/events"
  import {confirmTillingProcessing, startProcessing, getProcessingData} from "../../../api/api-project"
  import {DialogOptions} from "../../../helpers/dialogs"
  import {addUpdateProcessing} from "../../../api/api-billing"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import {UploaderEventBus} from "../../../helpers/upload/events"

  const ProcessingLastStep = Symbol.for("ProcessingLastStep")

  export default {
    name: "ProcessingSummary",
    components: {ProcessingSummaryItems},
    inject: {LastStep: ProcessingLastStep},
    data: () => ({
      isLoading: true,
      isLoadingNext: false,
      processingInfo: [],
      zipReadError: false
    }),
    methods: {
      onZipReadError(val) {
        this.zipReadError = val
      },
      onNextClick() {
        this.isLoadingNext = true

        if (this.processingTypeIsTilling) {
          const authToken = this.$apiAuth.getAuthToken()
          confirmTillingProcessing(authToken, this._idProcessing)
            .then(() => {
              const title = `Começar processamento: ${this._processingData["nm_processing"]}`
              const content = "Após a confirmação seu processamento começará automaticamente."
              this.$dialog(new DialogOptions({
                title: title,
                content: content,
                cancelText: "Ok, entendi",
                persistent: true,
                onCancel: () => {
                  this.isLoadingNext = false
                  this.$router.push("/app/")
                },
              }))
            })
        } else {
          if (this.$subsMng.subscriptionPlanConfig["bl_charge_processing"] ||
            (this._processingData["bl_gcp"] && this.$subsMng.subscriptionPlanConfig["bl_charge_gcp"])
          ) {
            const cartData = {
              str_description: "Processamento de imagens",
              is_intl: this.$appMng.isIntl,
              cd_processing: this._idProcessing
            }
            addUpdateProcessing(this.$apiAuth.getAuthToken(), cartData)
              .then((res) => {
                const shoppingCart = res.data.data
                const length = shoppingCart["processing_cart"].length + shoppingCart["post_processing_cart"].length + shoppingCart["subscription_cart"].length
                this.$appMng.setShoppingCartLength(length)
                this.$router.push("/app/payment")
              })
          } else {
            this.startProcessing()
          }
          this.isLoadingNext = false
        }
      },
      startProcessing() {
        const authToken = this.$apiAuth.getAuthToken()
        startProcessing(authToken, this._idProcessing)
          .then(() => {
            this.$router.push("/app/")
          })
      },
      loadInfo() {
        this.$nextTick(function () {
        this.isLoading = true
        const authToken = this.$apiAuth.getAuthToken()
        getProcessingData(authToken,this._idProcessing)
          .then((res) => {
            this._processingData = res.data.data
            const nmProcessing = this._processingData["nm_processing"]
            const intTotalImages = this._processingData["int_total_images"]
            const abProcessingTypeDisplay = processingTypeToName(this._processingData["ab_processing_type"])

            let intEstimatedTimeSecs
            if (isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.TILLING)) {
              intEstimatedTimeSecs = moment.duration(1800 * 1000).locale("pt-br").humanize()
            } else {
              intEstimatedTimeSecs = this._processingData["int_estimated_time_secs"] || 3600 * 2
              intEstimatedTimeSecs = moment.duration(intEstimatedTimeSecs * 1000).locale("pt-br").humanize()
            }

            this.processingInfo = [
              {title: "PROJETO", value: nmProcessing},
              {title: "IMAGENS", value: intTotalImages},
              {title: "TEMPO ESTIMADO", value: intEstimatedTimeSecs},
              {title: "TIPO DE IMAGEM", value: abProcessingTypeDisplay},
            ]

            if (this.processingTypeIsTilling) {
              this.processingInfo = this.processingInfo.filter((el) => {
                return el.title !== "IMAGENS"
              })
            } else {
              this.processingInfo = [
                ...this.processingInfo,
                {
                  title: "CAMERA",
                  value: cameraTypeToName(this._processingData["ab_camera_type"]),
                },
                {
                  title: "TIPO DE PROCESSAMENTO",
                  value: templateTypeToName(this._processingData["ab_processing_template"], this._processingData["ab_camera_type"]),
                },
                {
                  title: "LOG DE VOO",
                  value: georeferenceTypeToName(this._processingData["ab_camera_type"], this._processingData["ab_georeference_type"]),
                },
                {
                  title: "POSSUI GCP",
                  value: this._processingData["bl_gcp"],
                },
              ]
            }
            this.isLoading = false
          }).catch(() => {
            this.$notify(new NotificationOptions({
              message: "Não foi possivel Carregar as Informações do Processamento.",
              type: NOTIFICATION_TYPES.WARNING,
            }))
            this.$router.push("/app/")
          })
        })
      },
      populateProcessingInfo() {
        this.$nextTick(function () {
          if (this.mustCalculateProcessingData) {
            this.isLoading = true
            const data = {
              zipReadError: this.zipReadError
            }
            const idProcessing = this._idProcessing
            console.log(data)
            this.calculateProcessingData({idProcessing, data})
              .then(() => {
                const nmProcessing = this._processingData["nm_processing"]
                const intTotalImages = this._processingData["int_total_images"]
                console.log(intTotalImages)
                const abProcessingTypeDisplay = processingTypeToName(this._processingData["ab_processing_type"])

                let intEstimatedTimeSecs
                if (isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.TILLING)) {
                  intEstimatedTimeSecs = moment.duration(1800 * 1000).locale("pt-br").humanize()
                } else {
                  intEstimatedTimeSecs = this._processingData["int_estimated_time_secs"] || 3600 * 2
                  intEstimatedTimeSecs = moment.duration(intEstimatedTimeSecs * 1000).locale("pt-br").humanize()
                }

                this.processingInfo = [
                  {title: "PROJETO", value: nmProcessing},
                  {title: "IMAGENS", value: intTotalImages},
                  {title: "TEMPO ESTIMADO", value: intEstimatedTimeSecs},
                  {title: "TIPO DE IMAGEM", value: abProcessingTypeDisplay},
                ]

                if (this.processingTypeIsTilling) {
                  this.processingInfo = this.processingInfo.filter((el) => {
                    return el.title !== "IMAGENS"
                  })
                } else {
                  this.processingInfo = [
                    ...this.processingInfo,
                    {
                      title: "CAMERA",
                      value: cameraTypeToName(this._processingData["ab_camera_type"]),
                    },
                    {
                      title: "TIPO DE PROCESSAMENTO",
                      value: templateTypeToName(this._processingData["ab_processing_template"], this._processingData["ab_camera_type"]),
                    },
                    {
                      title: "LOG DE VOO",
                      value: georeferenceTypeToName(this._processingData["ab_camera_type"], this._processingData["ab_georeference_type"]),
                    },
                    {
                      title: "POSSUI GCP",
                      value: this._processingData["bl_gcp"],
                    },
                  ]
                }
                this.isLoading = false
              })
          } else {
            const nmProcessing = this._processingData["nm_processing"]
            const intTotalImages = this._processingData["int_total_images"]
            console.log(intTotalImages)
            const abProcessingTypeDisplay = processingTypeToName(this._processingData["ab_processing_type"])

            let intEstimatedTimeSecs
            if (isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.TILLING)) {
              intEstimatedTimeSecs = moment.duration(1800 * 1000).locale("pt-br").humanize()
            } else {
              intEstimatedTimeSecs = this._processingData["int_estimated_time_secs"] || 3600 * 2
              intEstimatedTimeSecs = moment.duration(intEstimatedTimeSecs * 1000).locale("pt-br").humanize()
            }

            this.processingInfo = [
              {title: "PROJETO", value: nmProcessing},
              {title: "IMAGENS", value: intTotalImages},
              {title: "TEMPO ESTIMADO", value: intEstimatedTimeSecs},
              {title: "TIPO DE IMAGEM", value: abProcessingTypeDisplay},
            ]

            if (this.processingTypeIsTilling) {
              this.processingInfo = this.processingInfo.filter((el) => {
                return el.title !== "IMAGENS"
              })
            } else {
              this.processingInfo = [
                ...this.processingInfo,
                {
                  title: "CAMERA",
                  value: cameraTypeToName(this._processingData["ab_camera_type"]),
                },
                {
                  title: "TIPO DE PROCESSAMENTO",
                  value: templateTypeToName(this._processingData["ab_processing_template"], this._processingData["ab_camera_type"]),
                },
                {
                  title: "LOG DE VOO",
                  value: georeferenceTypeToName(this._processingData["ab_camera_type"], this._processingData["ab_georeference_type"]),
                },
                {
                  title: "POSSUI GCP",
                  value: this._processingData["bl_gcp"],
                },
              ]
            }
            this.isLoading = false
          }
        })
      },
      onStepEnter(step) {
        if (!isEqual(step, PROCESSING_STEPS.SUMMARY)) return

        if (!this._processingData) {
          this.$router.push("/app/")
          return
        }
        console.log("Populando dados...")
        this.populateProcessingInfo()
        //this.loadInfo()
      },
      ...mapActions({
        calculateProcessingData: CALCULATE_PROCESSING_DATA,
      }),
    },
    computed: {
      processingTypeIsTilling() {
        if (!this._processingData)
          return false
        return isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.TILLING)
      },
      ...mapGetters({
        _idProcessing: GET_ID_PROCESSING,
        _processingData: GET_PROCESSING_DATA,
        mustCalculateProcessingData: GET_MUST_CALCULATE_PROCESSING_DATA,
      }),
    },
    created() {
      ProcessingStepperEventBus.$on("step-change", this.onStepEnter)
    },
    mounted() {
      UploaderEventBus.$on("zip-read-error", this.onZipReadError)
    }
  }
</script>

<style scoped lang="scss">
  .actions {
    .v-btn {
      margin: 0 5px;
    }
  }
</style>
